// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    loadYoutubePlaylistApi,
    LoadYoutubePlaylistApiParameter,
    loadYoutubePlaylistVideosApi,
} from "@mcmc/App/Services/MediaService";

type HandlerType = ApiHandler<LoadYoutubePlaylistApiParameter & { key : string }, {}>;

interface YoutubePlaylistVideo {
    title: string;
    id: string;
}

export interface YoutubePlaylistData {
    title: string;
    videos: YoutubePlaylistVideo[];
}

export const BeginLoadYoutubePlaylist: HandlerType = (props: any) => {
    props.dispatch({
        type: "xYoutubeMedia/BeginLoadYoutubePlaylist",
    });
};

export const FetchYoutubePlaylist: HandlerType = async props => {
    try {
        const [playlistInfo, playlistVideos] = await Promise.all([
            loadYoutubePlaylistApi(props.parameter),
            loadYoutubePlaylistVideosApi(props.parameter),
        ]);
        const videos: YoutubePlaylistVideo[] = playlistVideos.items.map(d => ({
            title: d.snippet.title,
            id: d.contentDetails.videoId,
        }));
        const items = playlistInfo.items;
        const firstItem = items ? playlistInfo.items[0] : null;
        const playlistData: YoutubePlaylistData = {
            title: items && firstItem ? firstItem.snippet.title : "",
            videos,
        };

        props.apiResult = playlistData;
    } catch (error) {
        return error.errorMessage;
    }
};

export const CompleteLoadYoutubePlaylist: HandlerType = (props: any) => {
    props.dispatch({
        type: "xYoutubeMedia/CompleteLoadYoutubePlaylist",
        playlistData: props.apiResult,
        key: props.parameter.key,
    });
};

const chain = [BeginLoadYoutubePlaylist, FetchYoutubePlaylist, CompleteLoadYoutubePlaylist];

const loadYoutubePlaylistData = createHandlerChainRunner(chain, "LoadYoutubePlaylist");
export default loadYoutubePlaylistData;
